import { render, staticRenderFns } from "./freightInquiry.vue?vue&type=template&id=6c44e494&scoped=true"
import script from "./freightInquiry.vue?vue&type=script&lang=js"
export * from "./freightInquiry.vue?vue&type=script&lang=js"
import style0 from "./freightInquiry.vue?vue&type=style&index=0&id=6c44e494&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c44e494",
  null
  
)

export default component.exports